import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { protectedResources } from "../config/authConfig";
import moment from "moment";
///////////////////////////////////////////////////////////////////

export var capitalizeFirstLetter = (stringValue) => {
  return stringValue[0].toUpperCase() + stringValue.slice(1);
};

///////////////////////////////////////////////////////////////////

const s4 = function () {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

export var guid = function () {
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
};

///////////////////////////////////////////////////////////////////

export var removePremium = (value, premium) => {
  return value / (1 + 0.01 * premium);
};

///////////////////////////////////////////////////////////////////

export function hexToRgb(hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

///////////////////////////////////////////////////////////////////

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

export function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function getSpacer() {
  return <div className="spacer">&nbsp;</div>;
}

export function getParams() {
  var pairs = window.location.search.substring(1).split("&"),
    obj = {},
    pair,
    i;

  for (i in pairs) {
    if (pairs[i] === "") continue;

    pair = pairs[i].split("=");
    obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }

  return obj;
}

export function copy(objectItem) {
  return objectItem ? JSON.parse(JSON.stringify(objectItem)) : null;
}

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function roundTo(num, nearestTens) {
  if (!parseFloat(num)) {
    console.log("Value provided to 'roundTo' function is not a number");
    return "";
  }
  if (!nearestTens || !parseInt(nearestTens)) {
    console.log(
      "Value provided to 'nearestTens' must be a tens value (10,100,1000,etc)",
    );
    return "";
  }
  return Math.round(num / nearestTens) * nearestTens;
}

export const decodeHTML = (html) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

export const moneyMask = (value, trailingDec) => {
  const decimalPlaces =
    trailingDec !== undefined && trailingDec !== null ? trailingDec : 2;
  // console.log("decimalPlaces", decimalPlaces);
  if (value === undefined || value === null) {
    // console.log("VALUE IS UNDEFINED");
    return "$0";
  }
  if (typeof value === "number") {
    value = value.toString();
  }
  // console.log("MONEY value", value);
  value = value.replace(",", "");
  //	value = value.replace('.', '').replace(',', '').replace(/\D/g, '')

  const options = { minimumFractionDigits: decimalPlaces };
  const result = new Intl.NumberFormat("en-US", options).format(
    parseFloat(value).toFixed(decimalPlaces),
  );

  // console.log(result)

  return "$" + result;
};

export const maskDateAs = (mask, date, diveder) => {
  let dateParsed = new moment(date);
  if (mask === "ymd") {
    return dateParsed.format("YYYY-MM-DD");
  }
  if (mask === "mdy") {
    return dateParsed.format("MM/DD/YYYY");
  }
};

export const maskDateAsDeprecated = (mask, date, divider) => {
  // console.log("type", typeof date, date, mask)
  if (typeof date === "string") {
    console.log(
      "maskDateAs requires a date object.  Date is of type " + typeof date,
    );
    return "";
  }
  var mm = date.getMonth() + 1; // getMonth() is zero-based
  var dd = date.getDate();

  if (mask === "ymd") {
    return [
      date.getFullYear(),
      divider || "-",
      addZ(mm),
      divider || "-",
      addZ(dd),
    ].join("");
  }
  if (mask === "mdy") {
    return [
      addZ(mm),
      divider || "/",
      addZ(dd),
      divider || "/",
      date.getFullYear(),
    ].join("");
  }
};

export const addZ = (n) => (n < 10 ? `0${n}` : `${n}`);

export const sortTableByNumeric = (a, b, columnId) => {
  // console.log(
  // 	"A", (columnId ? a.original[columnId] : a),
  // 	"B", (columnId ? b.original[columnId] : b),
  // 	columnId
  // )
  const sortNumA = parseFloat(columnId ? a.original[columnId] : a);
  const sortNumB = parseFloat(columnId ? b.original[columnId] : b);
  return sortNumA - sortNumB;
};

export const sortTableByDate = (a, b, columnId) => {
  // console.log(
  // 	"A", (columnId ? a.original[columnId] : a),
  // 	"B", (columnId ? b.original[columnId] : b),
  // 	columnId
  // )
  const sortDateA = new Date(columnId ? a.original[columnId] : a);
  const sortDateB = new Date(columnId ? b.original[columnId] : b);
  return sortDateA - sortDateB;
};

const authFetch = async ({
  path,
  method,
  headers = new Headers(),
  data,
  instance,
  account,
  resource = "apiCompensation",
  signal,
}) => {
  const options = {};
  try {
    let isFile = false;
    const authResp = await instance.acquireTokenSilent({
      scopes: protectedResources[resource].scopes,
      account: account,
    });
    const bearer = `Bearer ${authResp.accessToken}`;
    headers.append("Authorization", bearer);
    options.headers = headers;
    options.method = method ? method : "GET";
    if (options.method === "FILE") {
      options.method = "POST";
      isFile = true;
    }
    if (signal) {
      options.signal = signal;
    }
    if (data && !isFile) {
      options.body = JSON.stringify(data);
    }
    if (data && isFile) {
      options.body = data;
    }
    let response = fetch(path, options);
    return response;
  } catch (err) {
    console.log("err", err);
    if (err instanceof InteractionRequiredAuthError) {
      if (account) {
        let authRespRetry = await instance.acquireTokenRedirect({
          scopes: protectedResources.apiCompensation.scopes,
        });
        options.headers.set(
          "Authorization",
          `Bearer ${authRespRetry.accessToken}`,
        );
        let response = fetch(path, options);
        return response;
      }
    } else if (err.name === "AbortError") {
      console.info(`Aborted call to ${path}`);
    } else {
      Promise.reject(err);
    }
  }
};

export async function getData(path = "", instance, account, isRaw) {
  const controller = new AbortController();
  const signal = controller.signal;
  let resp = await authFetch({ path, instance, account, signal });
  let returnData = !isRaw ? await resp.json() : resp;
  if (resp.status !== 200) throw Error(returnData.message);
  return returnData;
}

export async function putData(path = "", data = {}, instance, account) {
  const controller = new AbortController();
  const signal = controller.signal;
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const resp = await authFetch({
    path,
    method: "PUT",
    data: data,
    headers,
    instance,
    account,
    signal,
  });
  if (resp.status !== 200) {
    throw new Error(
      `Error posting to ${path}, response: ${JSON.stringify(resp)}`,
    );
  }
  let returnData = await resp.json();
  return returnData;
}

export async function postData(path = "", data = {}, instance, account) {
  const controller = new AbortController();
  const signal = controller.signal;
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const resp = await authFetch({
    path,
    method: "POST",
    data: data,
    headers,
    instance,
    account,
    signal,
  });
  if (resp.status !== 200) {
    throw new Error(
      `Error posting to ${path}, response: ${JSON.stringify(resp)}`,
    );
  }
  let returnData = await resp.json();
  return returnData;
}

export async function deleteData(path = "", instance, account) {
  const controller = new AbortController();
  const signal = controller.signal;
  let resp = await authFetch({
    path,
    method: "DELETE",
    instance,
    account,
    signal,
  });
  if (resp.status !== 200) throw Error(resp);
  let returnData = await resp.json();
  return returnData;
}

export async function postFile(path = "", data = {}, instance, account) {
  const controller = new AbortController();
  const signal = controller.signal;
  const headers = new Headers();
  const resp = await authFetch({
    path,
    method: "FILE",
    data: data,
    headers,
    instance,
    account,
    signal,
  });
  if (resp.status !== 200) {
    throw new Error(
      `Error posting to ${path}, response: ${JSON.stringify(resp)}`,
    );
  }
  // let returnData = await resp.json();
  return resp;
}

///////////////////////////////////////////////////////////////////
// Job Title Alias Suggestion Utilities
///////////////////////////////////////////////////////////////////

/**
 * Find the closest matching salary range title for a given job title.
 * Accounts for numbered variants (e.g., "project engineer 2" matches "project engineer 2" not "1").
 */
export const findClosestTitleMatch = (jobTitleLower, candidateTitles) => {
  if (!candidateTitles || !candidateTitles.length) return null;

  // Extract trailing number if present
  const numberMatch = jobTitleLower.match(/\s(\d+)\s*$/);
  const jobNumber = numberMatch ? numberMatch[1] : null;
  const jobTitleBase = jobTitleLower.replace(/\s\d+\s*$/, "").trim();

  let bestMatch = null;
  let bestScore = -1;

  const jobWords = jobTitleBase.split(/[\s/]+/).filter(w => w.length > 2);

  for (let i = 0; i < candidateTitles.length; i++) {
    const candidateLower = candidateTitles[i].toLowerCase();
    const candidateNumberMatch = candidateLower.match(/\s(\d+)\s*$/);
    const candidateNumber = candidateNumberMatch ? candidateNumberMatch[1] : null;
    const candidateBase = candidateLower.replace(/\s\d+\s*$/, "").trim();

    // Count word overlap between base titles
    let wordScore = 0;
    for (let j = 0; j < jobWords.length; j++) {
      if (candidateBase.includes(jobWords[j])) {
        wordScore++;
      }
    }

    // Composite score
    let score = wordScore * 10;

    if (jobNumber && candidateNumber) {
      if (jobNumber === candidateNumber) {
        score += 5;
      } else {
        score -= 5;
      }
    } else if (!jobNumber && !candidateNumber) {
      score += 3;
    } else if (jobNumber && !candidateNumber) {
      score -= 2;
    } else if (!jobNumber && candidateNumber) {
      score -= 2;
    }

    if (score > bestScore) {
      bestScore = score;
      bestMatch = candidateTitles[i];
    }
  }

  return bestScore >= 20 ? bestMatch : null;
};

/**
 * Suggest a salary range title for a given job title based on keyword rules.
 * Returns the suggested title or null if no suggestion can be made.
 * 
 * @param {string} jobTitle - The employee job title
 * @param {string[]} engineerRangeTitles - Salary range titles containing "engineer"
 * @param {string[]} scientistRangeTitles - Salary range titles containing "scientist"
 */
export const suggestTitleAlias = (jobTitle, engineerRangeTitles, scientistRangeTitles) => {
  const scientistKeywords = ["biologist", "ecologist", "hydrologist", "hydrogeologist", "geologist"];
  const lowerTitle = jobTitle.toLowerCase();

  // Rule 1: If the job title contains "engineer", find the closest matching engineer salary range title
  if (lowerTitle.includes("engineer")) {
    const match = findClosestTitleMatch(lowerTitle, engineerRangeTitles);
    if (match) return match;
  }

  // Rule 2: If the job title contains scientist-related keywords, normalize and match
  const matchedScientistKeyword = scientistKeywords.find(kw => lowerTitle.includes(kw));
  if (matchedScientistKeyword) {
    const normalizedTitle = lowerTitle.replace(matchedScientistKeyword, "scientist");
    const match = findClosestTitleMatch(normalizedTitle, scientistRangeTitles);
    if (match) return match;
  }

  // Rule 3: If the title contains "scientist" directly
  if (lowerTitle.includes("scientist")) {
    const match = findClosestTitleMatch(lowerTitle, scientistRangeTitles);
    if (match) return match;
  }

  return null;
};
